import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { BuyingPowerDetails } from '@zero/shared/util-models';
import { commonRoutes } from 'constants/web-app-constants';

@Component({
  selector: 'trade-create-buying-power',
  imports: [CommonModule, TranslocoPipe, RouterLink],
  templateUrl: './trade-create-buying-power.component.html',
  styleUrl: './trade-create-buying-power.component.scss',
})
export class TradeCreateBuyingPowerComponent {
  @Input() public buyingPowerDetails?: BuyingPowerDetails;
  @Input() public isBuyingPowerTooLow?: boolean;
  @Input() public isLeftAligned = false;

  public displayTooltip = false;
  public readonly lombardUrl = commonRoutes.postlogin.lombard;
}
